import { useRef, useState } from 'react';
import { FlexColumn } from '@make-software/tg-mini-app-ui';
import { useTheme } from 'styled-components';

import AccordionChevron from '@/shared/assets/icons/ic_chevron-up.svg';
import CheckmarkGreen from '@/shared/assets/icons/ic-checkmark-green.svg';

import {
  AccordionHeader,
  ChevronWrapper,
  AccordionBody,
  CriteriaItem,
  ParticipateText
} from './airdrop-eligibility-criteria.styled';

interface CriteriaCheckMarkProps {
  met: boolean;
}
const CriteriaCheckMark = ({ met }: CriteriaCheckMarkProps) => {
  const theme = useTheme();

  return (
    <svg width="18" height="18" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 1.5C7.11553 1.5 5.76216 1.91054 4.61101 2.67971C3.45987 3.44888 2.56266 4.54213 2.03285 5.82122C1.50303 7.1003 1.36441 8.50776 1.63451 9.86563C1.9046 11.2235 2.57129 12.4708 3.55026 13.4497C4.52922 14.4287 5.7765 15.0954 7.13437 15.3655C8.49224 15.6356 9.8997 15.497 11.1788 14.9672C12.4579 14.4373 13.5511 13.5401 14.3203 12.389C15.0895 11.2378 15.5 9.88447 15.5 8.5C15.5 6.64348 14.7625 4.86301 13.4497 3.55025C12.137 2.2375 10.3565 1.5 8.5 1.5ZM8.5 14.5C7.31332 14.5 6.15328 14.1481 5.16658 13.4888C4.17989 12.8295 3.41085 11.8925 2.95673 10.7961C2.5026 9.69974 2.38378 8.49334 2.61529 7.32946C2.8468 6.16557 3.41825 5.09647 4.25736 4.25736C5.09648 3.41824 6.16558 2.8468 7.32946 2.61529C8.49335 2.38378 9.69975 2.5026 10.7961 2.95672C11.8925 3.41085 12.8295 4.17988 13.4888 5.16658C14.1481 6.15327 14.5 7.31331 14.5 8.5C14.5 10.0913 13.8679 11.6174 12.7426 12.7426C11.6174 13.8679 10.0913 14.5 8.5 14.5Z"
        fill={met ? '#29F746' : theme.colors.mainGray}
      />

      {met && (
        <path
          d="M7.5 11.207L5 8.7065L5.7065 8L7.5 9.793L11.2925 6L12 6.7075L7.5 11.207Z"
          fill={met ? '#29F746' : theme.colors.mainGray}
        />
      )}
    </svg>
  );
};

interface AirdropEligibilityCriteriaProps {
  tasks: boolean;
  onchainActivity: boolean;
  balance: boolean;
  connectedWallet: boolean;
}

export const AirdropEligibilityCriteria = ({
  tasks,
  onchainActivity,
  balance,
}: AirdropEligibilityCriteriaProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const contentRef = useRef(null);

  const metCriteria =
    Number(tasks) + Number(balance) + Number(onchainActivity);
  const bodyMaxHeight =
    // @ts-ignore
    (isOpen && contentRef.current ? contentRef.current.scrollHeight + 40 : 0) + 'px';

  return (
    <div>
      <AccordionHeader isOpen={isOpen} justify={'space-between'} onClick={() => setIsOpen(!isOpen)}>
        <ParticipateText>
          Airdrop eligibility criteria{' '}
          {metCriteria == 3 ? (
            <img src={CheckmarkGreen} width={16} height={16} />
          ) : (
            <span>
              (
              <span
                style={{
                  color: metCriteria === 0 ? 'white' : '#29F746',
                  fontWeight: '700'
                }}>
                {metCriteria}
              </span>
              /3)
            </span>
          )}
        </ParticipateText>
        <ChevronWrapper isOpen={isOpen}>
          <img src={AccordionChevron} width={20} height={20} />
        </ChevronWrapper>
      </AccordionHeader>
      <AccordionBody isOpen={isOpen} style={{ maxHeight: bodyMaxHeight }}>
        <FlexColumn ref={contentRef} gap={12} style={{ margin: '20px' }}>
          <CriteriaItem met={tasks}>
            <CriteriaCheckMark met={tasks} />
            Have completed at least 5 tasks.
          </CriteriaItem>
          <CriteriaItem met={balance}>
            <CriteriaCheckMark met={balance} />
            Accumulated at least 10,000 fan points.
          </CriteriaItem>
          <CriteriaItem met={onchainActivity}>
            <CriteriaCheckMark met={onchainActivity} />
            Have voted at least 3 times.
          </CriteriaItem>
        </FlexColumn>
      </AccordionBody>
    </div>
  );
};
